// Store Locator List & City Tabs Filter Controller

const initStoreLocatorTabs = () => {
  const locatorSections = document.querySelectorAll('[data-store-locator]');

  locatorSections.forEach((section) => {
    const tabBtns = section.querySelectorAll('[data-tab-target]');
    const storeItems = section.querySelectorAll('.store-locator-item');

    if (tabBtns.length === 0 || storeItems.length === 0) return;

    // Filter items based on active city handle
    const filterCity = (targetCity) => {
      storeItems.forEach((item) => {
        const itemCity = item.dataset.city;
        if (targetCity === 'all' || itemCity === targetCity) {
          item.classList.remove('is-hidden');
        } else {
          item.classList.add('is-hidden');
        }
      });
    };

    // Initial filter (first tab active)
    const initialActiveTab = section.querySelector('[data-tab-target].is-active') || tabBtns[0];
    if (initialActiveTab) {
      filterCity(initialActiveTab.dataset.tabTarget);
    }

    tabBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const targetCity = btn.dataset.tabTarget;

        tabBtns.forEach((b) => {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });

        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');

        filterCity(targetCity);
      });
    });
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStoreLocatorTabs);
} else {
  initStoreLocatorTabs();
}
